import { Agentation } from "agentation";
import React from "react";

import { detectDeployEnv } from "../utils/environment";

export function AgentationToolbar(): React.ReactElement | null {
    if (detectDeployEnv() !== "local") {
        return null;
    }

    // Playwright runs against the local build — keep the toolbar out of
    // the accessibility tree there so its buttons/checkboxes don't
    // collide with role-based test locators.
    if (typeof navigator !== "undefined" && navigator.webdriver) {
        return null;
    }

    return <Agentation />;
}
